import { required, SchemaPathTree } from '@angular/forms/signals';
import { dateRangeOrder } from '@app/shared/forms/rules';
import { Currency } from '@app/shared/types/enums/currency.enum';
import { TimeUnits } from '@app/shared/types/enums/time-units.enum';
import { User } from '@app/shared/types/models/user/user.model';

/** Plain Signal Forms model of the project basic information (create dialog). */
export interface CreateProjectModel {
  name: string;
  description: string;
  avatarId: string;
  supervisor: User | null;
  client: User | null;
  startDate: Date | null;
  endDate: Date | null;
  estimation: {
    time: {
      amount: number | null;
      units: TimeUnits;
    };
    financial: {
      amount: number | null;
      currency: Currency | null;
    };
  };
  address: string;
}

/** Validation shared by the create and edit project forms. */
export function projectFormSchema(path: SchemaPathTree<CreateProjectModel>): void {
  required(path.name, { message: 'errors.required' });
  dateRangeOrder(path.startDate, path.endDate);
}
